<template>
  <div class="main">
    <div class="title">Langauge Resources</div>
      <hr>
      <h3>Kyrgyz</h3>

    <div class="language">
     <div class="resource-title"><a href="/kyrgyz-language-dialogues">Beginner Language Dialogues (work in progress)</a></div>

  </div>
  </div>
</template>
<script>
export default {
  name: "LanguageResources",
  data() {
    return {
      resources: {
        kyrgyz: {
          dialogues: [
            {
              number: 1,
              title: "At the Airport",
              url: "/video/at_the_airport"
            },
            {
              number: 2,
              title: "Getting Acquainted",
              url: "/video/getting_acquainted"
            },
            {
              number: 3,
              title: "Taking a Taxi",
              url: "/video/taking_a_taxi"
            },
            {
              number: 4,
              title: "At the Hotel",
              url: "/video/at_the_hotel"
            },
            {
              number: 5,
              title: "Public Transport",
              url: "/video/public_transport"
            },
            {
              number: 6,
              title: "Language Help",
              url: "/video/language_help"
            },
            {
              number: 7,
              title: "Going Shopping",
              url: "/video/going_shopping"
            },
            {
              number: 8,
              title: "At the Movies",
              url: "/video/at_the_movies"
            },
            {
              number: 9,
              title: "At a Cafe",
              url: "/video/at_a_cafe"
            }
          ]
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.main {
  .title {
    font-size: 1.5em;
  }
  .language {
    .resource-title {
      font-weight: bold;
    }
    display: flex;
    flex-direction: column;

    .resource {
      padding-left: 20px;
    }

    a {
      color: #084696;
      text-decoration: none;
    }
  }
}
</style>
